import React, { useEffect, useCallback } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import Loader from 'components/common/Loader';
import { gatewayClient } from 'utils/gatewayClient';
import { RootRoutes } from 'utils/routeGenerator';

const AuthPage = () => {
  const navigate = useNavigate();
  const { type } = useParams();
  const location = useLocation();
  const { tk, id, is_terminated } = queryString.parse(location.search);

  const fetchAssertion = useCallback(async () => {
    if (type !== 'magic' && type !== 'reset') {
      navigate(RootRoutes.login());
    }

    window.location.href = `${
      gatewayClient.defaults.baseURL
    }/auth/v2/login/${type}?id=${id}&tk=${tk}${
      is_terminated ? `&is_terminated=${is_terminated}` : ''
    }`;
  }, [type, navigate, id, tk, is_terminated]);

  useEffect(() => {
    fetchAssertion();
  }, [type, fetchAssertion]);

  return <Loader active />;
};

export default AuthPage;
